import { ToolsRoutes } from "./names";

import type { AppRouteRecordRaw } from "@/app/router/types/types";

// `/tools` has no page of its own since the connection check was removed: it opens the first
// Catalog page, so entering the workspace never lands on the not-found page.
export const homeRoutes: AppRouteRecordRaw[] = [
  {
    path: "",
    name: ToolsRoutes.HOME,
    redirect: { name: ToolsRoutes.CATALOG_PRODUCTS },
    meta: { showInMenu: false },
  },
];
